import { ReactElement } from "react";
import { Navigate } from "react-router-dom";
import { useAppSelector } from "hooks/useAppSelector";
import {
  authStatusSelector,
  userSelector,
} from "reduxStore/auth/selectors";
import { checkLoggedUserThunk } from "reduxStore/auth/thunks";
import { AdminRoutes } from "config/routes";
import { Box } from "@mui/material";

type Props = {
  element: ReactElement;
  roles: string[];
};

const ProtectedRoute = ({ element, roles }: Props) => {
  const user = useAppSelector(userSelector);
  const statuses = useAppSelector(authStatusSelector);
  const checkStatus = statuses[checkLoggedUserThunk.typePrefix];
  const checkingAuth =
    checkStatus?.pending ||
    (!checkStatus?.success && !checkStatus?.error);

  if (checkingAuth) {
    return <Box color="rgba(0,0,0,0.5)">...loading</Box>;
  }

  if (!user || !user?.role) {
    return <Navigate to={AdminRoutes.Login} replace />;
  }

  return roles.includes(user.role as string) ? (
    element
  ) : (
    <Navigate to={AdminRoutes.Home} />
  );
};

export default ProtectedRoute;
